import apiClient from "./client";

export const getAdminCourses = async () => {
  const response = await apiClient.get("/courses/admin");
  return response.data;
};

/**
 * Create/update every language variant of a course in one call.
 * Returns admin course rows (one per language) for that CourseKey.
 */
export const saveAdminCourseAllLanguages = async (payload) => {
  const response = await apiClient.post("/courses/admin/save", payload);
  return response.data;
};

export const createAdminCourse = async (payload) => {
  const response = await apiClient.post("/courses/admin", payload);
  return response.data;
};

export const updateAdminCourse = async ({ id, payload }) => {
  const response = await apiClient.put(`/courses/admin/${id}`, payload);
  return response.data;
};

export const deleteAdminCourse = async ({ id, allLanguages = true }) => {
  await apiClient.delete(`/courses/admin/${id}`, {
    params: { allLanguages },
  });
};
